import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Play, Pause } from 'lucide-react';

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Video/Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden bg-white shadow-[0_10px_40px_rgba(0,0,0,0.06)] border border-gray-50 flex items-center justify-center p-12" style={{ aspectRatio: '4/5', maxHeight: '600px' }}>
              {/* Product Image */}
              <img
                src="/assets/images/peach.png"
                alt="Seltz Peach"
                className="w-full h-full object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.15)] hover:scale-105 transition-transform duration-500"
              />
            </div>

            {/* Floating fruit decoration */}
            <div className="absolute -bottom-8 -left-6 hidden lg:block">
              <div
                className="w-20 h-20 rounded-full flex items-center justify-center text-3xl shadow-lg"
                style={{ background: '#f4b8c8' }}
              >
                🍊
              </div>
            </div>
          </div>

          {/* Right: Text content */}
          <div className="flex flex-col gap-6 lg:pl-8">


            <h2
              className="text-[#0a0a0a] font-black italic leading-tight"
              style={{
                fontFamily: 'Nunito, sans-serif',
                fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
              }}
            >
              bucură-te de
              <br />
              clipele bune
            </h2>

            <p
              className="text-[#0a0a0a] text-base md:text-lg leading-relaxed max-w-md"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              Pachetul Seltz Mix oferă arome vibrante de fructe: Grapefruit, Lămâie, Piersică și Cireșe Negre.
            </p>

            <div>
              <Link
                to="/shop"
                className="inline-block bg-[#0a0a0a] text-white font-black italic text-base px-10 py-4 rounded-full hover:bg-[#222222] transition-all duration-200 hover:scale-105 shadow-lg"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                cumpără seltz
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
